import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import TableLoader from "../../Loader/TableLoader";
import Swal from 'sweetalert2'; // Import SweetAlert

const ManageCustomerRole = () => {
  const [roleData, setRoleData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRoleData();
  }, []);

  const fetchRoleData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/get-role-list`);
      // console.log(response.data.data);
      setRoleData(response.data.data);
      setLoading(false);

    } catch (error) {
      console.error("Error fetching role data:", error);
      setLoading(false);
      
    }
  };

  // implement delete role using sweetalert2 

 

  const handleDeleteMenu = async (id) => {
    // Show SweetAlert2 confirmation dialog
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });
  
    // If the user confirms, proceed with the delete request
    if (result.isConfirmed) {
      // Show SweetAlert2 loading spinner
      Swal.fire({
        title: 'Deleting...',
        text: 'Please wait while we delete the role.',
        icon: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Display loading spinner
        }
      });
  
      setLoading(true); // Show loading state in your UI
  
      try {
        const response = await axios.post(`${API_BASE_URL}/delete-role`, {
          role_id: id , // Pass role_id as data in the request
        });
        console.log(response.data);
  
        // Hide the loading spinner and show success alert
        Swal.fire('Deleted!', 'The role has been deleted.', 'success');
  
        // Refresh the role data (or perform any other necessary action)
        fetchRoleData();
        setLoading(false); // Hide loading state in your UI
      } catch (error) {
        console.error("Error deleting role:", error);
  
        // Hide the loading spinner and show error alert
        Swal.fire('Error!', 'There was a problem deleting the role.', 'error');
        setLoading(false); // Hide loading state in your UI
      }
    }
  };
  

  // const handleDeleteMenu = async (id) => {
  //     setLoading(true);
  //     try {
  //       const response = await axios.delete(
  //         `${API_BASE_URL}/delete-role`,{
  //           role_id: id
  //         }
  //       );
  //       console.log(response.data);
  //       fetchRoleData();
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error deleting role:", error);
  //       setLoading(false);
  //     }
    
  // }

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Manage Customer Role</h4>
                </div>

                <div className="card">
                  <div className="card-body rounded-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h4 className="card-title mb-2">Role List</h4>
                    <div className="mb-2">
                      <Link
                        type="button"
                        className="btn btn-success inner"
                        to={"/cms/add-customer-role"}
                      >
                        Add Role <i className="fa fa-plus"></i>
                      </Link>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table align-middle table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Id</th>
                          <th>Role Name</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <TableLoader count={3} />
                        ) : roleData?.length > 0 ? (
                          roleData?.map((item) => (
                            <React.Fragment key={item.id}>
                              <tr>
                                <td>
                                  <strong>{item?.id}</strong>
                                </td>
                                <td>{item?.role_name}</td>
                                <td>
                                

                                  <Link
                                    className="btn btn-primary btn-sm ms-2"
                                    // onClick={() => handleEditMenu(menuItem)}
                                    to={`/cms/edit-customer-role/${item?.id}`}
                                  >
                                    <i className="fa fa-pen"></i>
                                  </Link>

                                  <button
                                    className="btn btn-danger btn-sm ms-2"
                                    onClick={() =>
                                      handleDeleteMenu(item?.id)
                                    }
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>

                            </React.Fragment>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center fw-bold">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageCustomerRole;
